/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* IMPORT MACHEN!!!!!  */
import { Fragment, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Checkbox from '../Elements/ViewCheckbox';
import { viewActions } from '../../../../Helpers/Stores/viewStore';
import { toDateFormat } from 'Helpers/dateHelper';
import Info from 'Components/Lib/Elements/Info';
import URLS from 'Components/Lib/Utils/URLs.API';
import MFXLocalStorage from 'Helpers/MFXLocalStorage';
import loadJsonData from 'Components/Lib/Utils/jsonGet';
import ReactSelect from 'Components/Lib/Elements/ReactSelect';

interface IGenericViewMenuProps {
    data: Object;
    onSelectFilter(e: any, id: any): void;
    filter?: any;
    curFilter?: number | any;
    tablehead: any;
    defaultSettings: any;
    isStatic?: boolean;
    viewName?: string;
    filterSelect?: any;
    filterType?: any;
    setFilterType(e: any): void;
}

export default function TableMenu(props: IGenericViewMenuProps) {
    const dispatch = useDispatch();
    const [checkboxSearch, setCheckboxSearch] = useState('' as string);
    const [withType, setWithType] = useState(false);
    const [withDBName, setWithDBName] = useState(false);
    const [profCrit, setProfCrit] = useState(null as any);

    const [settingsSelected, setSettingsSelected] = useState({
        default: false,
        table: true,
        filter: false,
        preMadeFilter: false,
    });

    function changeFilter(newValue: any, target: string, isProfCrit = false) {
        if (isProfCrit && profCrit) {
            dispatch(viewActions.changeProfCritFilter({ newValue: newValue, target: target, idx: props.curFilter, filterType: props.filterType, profCrit: profCrit }));
        } else {
            dispatch(viewActions.changeFilter({ newValue: newValue, target: target, idx: props.curFilter, filterType: props.filterType }));
        }
    }

    useEffect(() => {
        var type = '';
        switch (props.viewName) {
            case 'PreSalesView':
                type = 'Project';
                break;
            case 'ContactView':
                type = 'ContactPerson';
                break;
            case 'CustomerView':
                type = 'Customer';
                break;
            case 'TaskView':
                type = 'CrmTask';
                break;
            default:
                type = 'CrmProcess';
                break;
        }
        loadJsonData('/' + MFXLocalStorage?.getConnectionKey() + URLS.GetProfilingCriterionsFilled + type).then((data: any) => {
            if (data.Meta.Success && data.Data) {
                console.log(data);
                if (data.Data.ProfilingCriterionGroups?.[0]?.Criteria) setProfCrit(data.Data.ProfilingCriterionGroups?.[0]?.Criteria);
            }
        });
    }, []);

    function showSettings(type: string) {
        let newSettingsObject = { ...settingsSelected } as any;
        Object.keys(newSettingsObject).forEach(settings => {
            if (settings === type) newSettingsObject[type] = !newSettingsObject[type];
            else newSettingsObject[settings] = false;
        });
        setSettingsSelected(newSettingsObject);
    }
    function changeSettings(settingsObject: object) {
        dispatch(viewActions.changeData({ ...settingsObject, isStatic: props.isStatic }));
    }
    function removeFilter() {
        dispatch(viewActions.removeFilter({ idx: props.curFilter, filterType: props.filterType }));
        props.onSelectFilter(null, null);
    }
    function changeTableHead(target: any, curSelected: any, property: any) {
        dispatch(viewActions.changeTableHead({ target: target, prevTarget: curSelected, property: property }));
    }
    function changeDefaultSettings(value: any, target: any) {
        console.log(value);
        console.log(target);
        dispatch(viewActions.changeDefaultSettings({ target: target, newValue: value }));
    }
    function changeSortDescending(target: any) {
        dispatch(viewActions.changeSortDescending({ target: target }));
    }

    const [valueAccord, setValueAccord]: any = useState({});
    function ViewData(curdata: Object, index: string, type: string, withType = false, withDBName = false): any {
        if (Array.isArray(curdata)) curdata = curdata[0];
        if (!Object.entries(curdata).find((d: any) => d[1].Designable)) {
            return null;
        }
        return (
            <>
                {curdata &&
                    Object.entries(curdata)
                        .filter((data: any) => {
                            if (type !== 'Filter' && data[1].Label) return window.Dictionary.getTranslation(data[1].Label).toLowerCase().includes(checkboxSearch.toLowerCase());
                            return true;
                        })
                        .sort((a, b) => {
                            return !a[1].Designable && b[1].Designable ? 1 : window.Dictionary.getTranslation(a[1].Label) > window.Dictionary.getTranslation(b[1].Label) ? 1 : -1;
                        })
                        .map((key, idx) => {
                            if (type === 'Filter' && typeof key[1] === 'object' && key[1].Designable === true && (key[1].Label || key[1].Name)) {
                                if (key[1].HideFromFilters) {
                                    return <></>;
                                }
                                return (
                                    <option key={(index ? index + '-' : '') + key[0]} value={key[1].Key}>
                                        {(index ? index + '-' : '') + window.Dictionary.getTranslation(key[1].Label ?? key[1].Name) + (withType && key[1].Elementtype ? ' (' + (key[1].Type ?? key[1].Elementtype) + ')' : '') + (withDBName && key[1].DBName ? ' (' + key[1].DBName + ')' : '')}
                                    </option>
                                );
                            } else if (typeof key[1] === 'object' && key[1].Designable === true && (key[1].Label || key[1].Name)) {
                                return (
                                    <div key={idx}>
                                        <Checkbox
                                            designData={key[1]}
                                            checked={Object.entries(props.tablehead[0]).find((d: any) => d[1].Key === key[1].Key) ? true : false}
                                            uniqueKey={(index ? index + '-' : '') + key[0]}
                                            onChangeHandler={(settingsObject: object) => changeSettings(settingsObject)}
                                            withType={withType}
                                            withDBName={withDBName}
                                        />
                                    </div>
                                );
                            } else if ((Array.isArray(key[1]) || typeof key[1] === 'object') && !key[1].Designable && key[1].Designable !== false && ViewData(key[1], (index ? index + '-' : '') + key[0], type)) {
                                if (type === 'Filter') {
                                    return <>{ViewData(key[1], (index ? index + '-' : '') + key[0], type, withType, withDBName)}</>;
                                }
                                return (
                                    <Fragment key={idx}>
                                        <h4 onClick={() => setValueAccord({ ...valueAccord, [key[0]]: !valueAccord[key[0]] })}>{'-'.repeat(index ? index.split('-').length + 1 : 1) + key[0]}</h4>
                                        {(valueAccord[key[0]] || (checkboxSearch != null && checkboxSearch !== '')) && ViewData(key[1], (index ? index + '-' : '') + key[0], type, withType, withDBName)}
                                    </Fragment>
                                );
                            }
                            return <></>;
                        })}
            </>
        );
    }
    function setSpecificProperty(property: any) {
        let curSelected = Object.entries(props?.tablehead[0]).find(key => {
            return (key[1] as any)[property] === true;
        });
        curSelected = curSelected ? curSelected[0] : ('' as any);
        return (
            <select value={curSelected as any} onChange={e => changeTableHead(e.target.value, curSelected, property)}>
                <option value={''}></option>
                {Object.entries(props.tablehead[0]).map((e: any, idx: any) => {
                    return (
                        <>
                            <option key={idx} value={e[0]}>
                                {window.Dictionary.getTranslation(e[1].Name)}
                            </option>
                        </>
                    );
                })}
            </select>
        );
    }

    function getSortDescending() {
        let sortingColumnObj: any = Object.entries(props.tablehead[0]).find(key => {
            return (key[1] as any)['DefaultSortingColumn'] === true;
        });
        let sortingColumn = sortingColumnObj ? sortingColumnObj[1] : '';
        return (
            <>
                {sortingColumn && (
                    <>
                        <input
                            type="checkbox"
                            checked={sortingColumn.SortDescending ?? false}
                            onChange={e => {
                                console.log(e);
                                return changeSortDescending(sortingColumnObj[0]);
                            }}
                        />
                        <label>{window.Dictionary.getTranslation(14468)}</label>
                    </>
                )}
            </>
        );
    }

    useEffect(() => {
        // != to check both null and undefined
        if (!settingsSelected.filter && props.curFilter != null) showSettings('filter');
    }, [props.curFilter]);
    console.log(props);

    return (
        <div id="mfx-generic-view-menu">
            {props.tablehead && (
                <>
                    <div className="mfx-settings-accordion">
                        <h3 className={settingsSelected.table ? 'active' : ''} id={'accordion-settings-table'} onClick={() => showSettings('table')}>
                            {window.Dictionary.getTranslation(14467)}
                        </h3>
                        {settingsSelected.table && (
                            <div>
                                <div className="mfx-checkbox-element">
                                    <input
                                        id="withTypeCheckbox"
                                        type="checkbox"
                                        checked={withType}
                                        onClick={(e: any) => {
                                            setWithType(e.target.checked);
                                        }}
                                    />
                                    <label>
                                        {window.Dictionary.getTranslation(15166)} <Info text={window.Dictionary.getTranslation(15402)} />
                                    </label>
                                </div>
                                <div className="mfx-checkbox-element">
                                    <input
                                        id="withDBNameCheckbox"
                                        type="checkbox"
                                        checked={withDBName}
                                        onClick={(e: any) => {
                                            setWithDBName(e.target.checked);
                                        }}
                                    />
                                    <label>
                                        {window.Dictionary.getTranslation(17431)} <Info text={window.Dictionary.getTranslation(17433)} />
                                    </label>
                                </div>
                                <input id="checkboxsearch" placeholder={window.Dictionary.getTranslation(162)} value={checkboxSearch} onChange={e => setCheckboxSearch(e.target.value)} />
                                {ViewData(props.data, '', 'Table', withType, withDBName)}
                            </div>
                        )}
                    </div>
                </>
            )}
            <div className="mfx-settings-accordion">
                <h3 className={settingsSelected.default ? 'active' : ''} id={'accordion-settings-default'} onClick={() => showSettings('default')}>
                    {window.Dictionary.getTranslation(14466)}
                </h3>
                {settingsSelected.default && props.viewName !== 'PreSalesView' && (
                    <>
                        <div>
                            <label>
                                {window.Dictionary.getTranslation(14450)} <Info text={window.Dictionary.getTranslation(15403)} />
                            </label>
                            <input type="number" value={props?.defaultSettings?.NumberOfEntries ?? null} onChange={e => changeDefaultSettings(e.target.value, 'NumberOfEntries')} />
                        </div>
                        <div className="mfx-dropdown-element">
                            <label>
                                {window.Dictionary.getTranslation(14452)} <Info text={window.Dictionary.getTranslation(15404)} />
                            </label>

                            {setSpecificProperty('DefaultSortingColumn')}
                        </div>
                        <div className="mfx-checkbox-element">{getSortDescending()}</div>
                        <div className="mfx-checkbox-element">
                            <input
                                type="checkbox"
                                checked={props?.defaultSettings?.IsListView ?? false}
                                onChange={e => {
                                    console.log(e);
                                    return changeDefaultSettings(e.target.checked, 'IsListView');
                                }}
                            />
                            <label>
                                {window.Dictionary.getTranslation(14451)} <Info text={window.Dictionary.getTranslation(15167)}></Info>
                            </label>
                        </div>
                        <div className="mfx-checkbox-element">
                            <input
                                type="checkbox"
                                checked={props?.defaultSettings?.IsFilterClosed ?? false}
                                onChange={e => {
                                    console.log(e);
                                    return changeDefaultSettings(e.target.checked, 'IsFilterClosed');
                                }}
                            />
                            <label>
                                {window.Dictionary.getTranslation(15182)} <Info text={window.Dictionary.getTranslation(15183)}></Info>
                            </label>
                        </div>
                        <div>
                            <label>
                                {window.Dictionary.getTranslation(14866)} <Info text={window.Dictionary.getTranslation(15405)}></Info>
                            </label>
                            <input type="text" value={props?.defaultSettings?.ExtraFilter ?? ''} onChange={e => changeDefaultSettings(e.target.value, 'ExtraFilter')} />
                        </div>
                        <div className="mfx-checkbox-element">
                            {
                                <>
                                    <input
                                        type="checkbox"
                                        checked={props.defaultSettings?.SortDescending ?? false}
                                        onChange={e => {
                                            return changeDefaultSettings(e.target.checked, 'SortDescending');
                                        }}
                                    />
                                    <label>{window.Dictionary.getTranslation(14468)}</label>
                                </>
                            }
                        </div>
                        <div className="mfx-checkbox-element">
                            {
                                <>
                                    <input
                                        type="checkbox"
                                        checked={props.defaultSettings?.ShowOverflow ?? false}
                                        onChange={e => {
                                            return changeDefaultSettings(e.target.checked, 'ShowOverflow');
                                        }}
                                    />
                                    <label>{window.Dictionary.getTranslation(17300)}</label>
                                </>
                            }
                        </div>
                        <div>
                            <label>{window.Dictionary.getTranslation(17303)}</label>
                            <input type="number" value={props.defaultSettings?.MaxHeight ?? null} onChange={(e: any) => changeDefaultSettings(e.target.value, 'MaxHeight')} />
                        </div>
                    </>
                )}
                {settingsSelected.default && props.viewName === 'PreSalesView' && (
                    <>
                        <div className="mfx-dropdown-element">
                            <label>
                                {window.Dictionary.getTranslation(14452)} <Info text={window.Dictionary.getTranslation(15404)} />
                            </label>
                            {
                                <select value={props?.defaultSettings?.SortColumn as any} onChange={e => changeDefaultSettings(e.target.value, 'SortColumn')}>
                                    <option value={''}></option>
                                    {Object.entries(props.data)
                                        .filter((d: any) => !d[1].SpecialFilter)
                                        .map((e: any, idx: any) => {
                                            return (
                                                <>
                                                    <option key={idx} value={e[0]}>
                                                        {window.Dictionary.getTranslation(e[1].Label)}
                                                    </option>
                                                </>
                                            );
                                        })}
                                </select>
                            }
                        </div>
                        <div className="mfx-checkbox-element">
                            {
                                <>
                                    <input
                                        type="checkbox"
                                        checked={props.defaultSettings?.SortDescending ?? false}
                                        onChange={e => {
                                            return changeDefaultSettings(e.target.checked, 'SortDescending');
                                        }}
                                    />
                                    <label>{window.Dictionary.getTranslation(14468)}</label>
                                </>
                            }
                        </div>
                        <div className="mfx-checkbox-element">
                            {
                                <>
                                    <input
                                        type="checkbox"
                                        checked={props.defaultSettings?.ShowOverflow ?? false}
                                        onChange={e => {
                                            return changeDefaultSettings(e.target.checked, 'ShowOverflow');
                                        }}
                                    />
                                    <label>{window.Dictionary.getTranslation(17300)}</label>
                                </>
                            }
                        </div>
                        <div>
                            <label>{window.Dictionary.getTranslation(17303)}</label>
                            <input type="number" value={props.defaultSettings?.MaxHeight ?? null} onChange={(e: any) => changeDefaultSettings(e.target.value, 'MaxHeight')} />
                        </div>
                    </>
                )}
            </div>

            {!props.isStatic && (
                <div className="mfx-settings-accordion">
                    <h3 className={settingsSelected.filter ? 'active' : ''} id={'accordion-settings-filter'} onClick={() => showSettings('filter')}>
                        {window.Dictionary.getTranslation(14465)}
                    </h3>
                    {settingsSelected.filter && (
                        <>
                            {props.viewName === 'PreSalesView' && (
                                <>
                                    <h5>{window.Dictionary.getTranslation(17216)}</h5>
                                    <ReactSelect
                                        classNamePrefix={'mfx-designer-select-layout'}
                                        onChange={(newValue: any) => {
                                            props.setFilterType(newValue.value >= 0 ? 'PreMadeFilters.' + newValue.value : 'Filter');
                                        }}
                                        onCreateOption={e => {
                                            dispatch(viewActions.addPreMadeFilter({ name: e }));
                                            props.setFilterType('PreMadeFilters.' + (props.filterSelect?.length ? props.filterSelect?.length - 1 : -1));
                                        }}
                                        options={props.filterSelect?.map((f: any, inx: any) => {
                                            return { label: f, value: inx - 1 };
                                        })}
                                        value={{ label: props.filterSelect?.[+props.filterType?.split('.')?.[1] + 1], value: +props.filterType?.split('.')?.[1] }}></ReactSelect>
                                    <br />
                                    <button
                                        className="mfx-button button-border"
                                        onClick={e => {
                                            dispatch(viewActions.removePreMadeFilter({ filter: +props.filterType?.split('.')?.[1] }));
                                            props.setFilterType('Filter');
                                        }}>
                                        {window.Dictionary.getTranslation(17676)}
                                    </button>
                                </>
                            )}
                            {props.curFilter === null && <label>{window.Dictionary.getTranslation(14464)}</label>}
                            {props.curFilter !== null && props.filter?.Data[props.curFilter] && (
                                <>
                                    <div className="mfx-checkbox-element">
                                        <input
                                            id="withTypeCheckbox"
                                            type="checkbox"
                                            checked={withType}
                                            onClick={(e: any) => {
                                                setWithType(e.target.checked);
                                            }}
                                        />
                                        <label>
                                            {window.Dictionary.getTranslation(15166)} <Info text={window.Dictionary.getTranslation(15402)} />
                                        </label>
                                    </div>
                                    <div className="mfx-dropdown-element">
                                        <label>{window.Dictionary.getTranslation(11349)}</label>
                                        <select
                                            value={props.filter.Data[props.curFilter].Key ?? ''}
                                            onChange={e => {
                                                const selectedOption = e.target.selectedOptions[0];
                                                const isProfCrit = selectedOption?.dataset.profcrit === 'true';
                                                changeFilter(e.target.value, 'Key', isProfCrit);
                                            }}>
                                            <option value={''}></option>
                                            {Object.entries(props.data)
                                                .filter((d: any) => d[1].SpecialFilter)
                                                .map((d: any) => {
                                                    return (
                                                        <option key={d[1].Key} value={d[1].Key}>
                                                            ({window.Dictionary.getTranslation(16402)}) {window.Dictionary.getTranslation(d[1].Label)}
                                                        </option>
                                                    );
                                                })}
                                            {ViewData(props.data, '', 'Filter', withType, withDBName)}
                                            {profCrit &&
                                                profCrit.map((d: any) => {
                                                    return (
                                                        <option key={d.Criteria} value={d.Criteria} data-profcrit="true">
                                                            ({window.Dictionary.getTranslation(2350)}) {window.Dictionary.getTranslation(d.Name)}
                                                        </option>
                                                    );
                                                })}
                                        </select>
                                    </div>
                                    <label>{window.Dictionary.getTranslation(14469)}</label>
                                    <input type="text" value={window.Dictionary.getTranslation(props.filter.Data[props.curFilter].Label)} onChange={e => changeFilter(e.target.value, 'Label')} />

                                    <div className="mfx-dropdown-element">
                                        <label>{window.Dictionary.getTranslation(53)}</label>
                                        <select value={props.filter.Data[props.curFilter].Type} onChange={e => changeFilter(e.target.value, 'Type')}>
                                            <option value={'bool'}>{window.Dictionary.getTranslation(16405)}</option>
                                            <option value={'boolnon'}>{window.Dictionary.getTranslation(14453)}</option>
                                            <option value={'date'}>{window.Dictionary.getTranslation(7)}</option>
                                            <option value={'datetime-local'}>{window.Dictionary.getTranslation(17411)}</option>
                                            <option value={'number'}>{window.Dictionary.getTranslation(6)}</option>
                                            <option value={'text'}>{window.Dictionary.getTranslation(545)}</option>
                                            <option value={'dropdown'}>{window.Dictionary.getTranslation(1672)}</option>
                                            <option value={'dropdownMulti'}>{window.Dictionary.getTranslation(17410)}</option>
                                        </select>
                                    </div>
                                    <div className="mfx-dropdown-element">
                                        {props.filter.Data[props.curFilter].Type !== 'bool' && props.filter.Data[props.curFilter].Type !== 'boolnon' && props.filter.Data[props.curFilter].SpecialFilter !== true && (
                                            <>
                                                <label>{window.Dictionary.getTranslation(5680)}</label>
                                                <input
                                                    type={props.filter.Data[props.curFilter].Type ?? 'text'}
                                                    value={props.filter.Data[props.curFilter].DefaultValue}
                                                    onChange={e => changeFilter(props.filter.Data[props.curFilter].Type !== 'date' ? e.target.value : toDateFormat(e.target.value), 'DefaultValue')}
                                                />
                                            </>
                                        )}
                                        {(props.filter.Data[props.curFilter].Type === 'bool' || props.filter.Data[props.curFilter].Type === 'boolnon') && props.filter.Data[props.curFilter].SpecialFilter !== true && (
                                            <>
                                                <label>{window.Dictionary.getTranslation(5680)}</label>
                                                <select value={props.filter.Data[props.curFilter].DefaultValue} onChange={e => changeFilter(e.target.value, 'DefaultValue')}>
                                                    <option value={''}></option>
                                                    <option value={1}>{window.Dictionary.getTranslation(1651)}</option>
                                                    <option value={0}>{window.Dictionary.getTranslation(1652)}</option>
                                                </select>
                                            </>
                                        )}
                                        {props.filter.Data[props.curFilter].SpecialFilter === true && (
                                            <>
                                                <label>{window.Dictionary.getTranslation(5680)}</label>
                                                <h5>{window.Dictionary.getTranslation(16366)}</h5>
                                            </>
                                        )}
                                    </div>
                                    <div className="mfx-checkbox-element">
                                        <input id="readonly" type={'checkbox'} checked={props.filter.Data[props.curFilter].ReadOnly} onChange={e => changeFilter(e.target.checked, 'ReadOnly')} />
                                        <label htmlFor="readonly">{window.Dictionary.getTranslation(14933)}</label>
                                    </div>
                                    {(props.filter.Data[props.curFilter].Type === 'date' || props.filter.Data[props.curFilter].Type === 'datetime-local') && (
                                        <div className="mfx-checkbox-element">
                                            <input id="date-now" type={'checkbox'} checked={props.filter.Data[props.curFilter].DefaultValue === 'NOW'} onChange={e => changeFilter(e.target.checked ? 'NOW' : '', 'DefaultValue')} />
                                            <label htmlFor="date-now">{window.Dictionary.getTranslation(12152)}</label>
                                        </div>
                                    )}
                                    {(props.filter.Data[props.curFilter].Type === 'date' || props.filter.Data[props.curFilter].Type === 'datetime-local') && props.filter.Data[props.curFilter].DefaultValue === 'NOW' && (
                                        <>
                                            <div className="mfx-dropdown-element">
                                                <label>{window.Dictionary.getTranslation(16986)}</label>
                                                <input type={'number'} value={props.filter.Data[props.curFilter].DefaultValueOffset} onChange={e => changeFilter(e.target.value, 'DefaultValueOffset')} />
                                            </div>
                                        </>
                                    )}
                                    {(props.filter.Data[props.curFilter].Type === 'date' || props.filter.Data[props.curFilter].Type === 'datetime-local') && (
                                        <div className="mfx-dropdown-element">
                                            <label>{window.Dictionary.getTranslation(16402)}</label>
                                            <select value={props.filter.Data[props.curFilter].DefaultValue} onChange={e => changeFilter(e.target.value, 'DefaultValue')}>
                                                <option value={''}></option>
                                                <option value={'q1'}>{window.Dictionary.getTranslation(17281)}</option>
                                                <option value={'q2'}>{window.Dictionary.getTranslation(17282)}</option>
                                                <option value={'q3'}>{window.Dictionary.getTranslation(17283)}</option>
                                                <option value={'q4'}>{window.Dictionary.getTranslation(17284)}</option>
                                                <option value={'qN'}>{window.Dictionary.getTranslation(17285)}</option>
                                                <option value={'h1'}>{window.Dictionary.getTranslation(17286)}</option>
                                                <option value={'h2'}>{window.Dictionary.getTranslation(17287)}</option>
                                                <option value={'hN'}>{window.Dictionary.getTranslation(17288)}</option>
                                            </select>
                                        </div>
                                    )}
                                    {(props.filter.Data[props.curFilter].Type === 'date' ||
                                        props.filter.Data[props.curFilter].Type === 'datetime-local' ||
                                        props.filter.Data[props.curFilter].Type === 'number' ||
                                        props.filter.Data[props.curFilter].Type === 'text' ||
                                        props.filter.Data[props.curFilter].Type === 'dropdownMulti') && (
                                        <div className="mfx-dropdown-element">
                                            <label>{window.Dictionary.getTranslation(918)}</label>
                                            <select value={props.filter.Data[props.curFilter].Operator ? props.filter.Data[props.curFilter].Operator : ''} onChange={e => changeFilter(e.target.value, 'Operator')}>
                                                {props.filter.Data[props.curFilter].Type !== 'dropdownMulti' && (
                                                    <>
                                                        <option value={''}></option>
                                                        <option value={'='}>{'='}</option>
                                                        <option value={'!='}>{'!='}</option>
                                                        <option value={'IS'}>{'IS'}</option>
                                                        <option value={'IS NOT'}>{'IS NOT'}</option>
                                                    </>
                                                )}
                                                {(props.filter.Data[props.curFilter].Type === 'date' || props.filter.Data[props.curFilter].Type === 'datetime-local' || props.filter.Data[props.curFilter].Type === 'number') && (
                                                    <>
                                                        <option value={'>'}>{'>'}</option>
                                                        <option value={'<'}>{'<'}</option>
                                                        <option value={'>='}>{'>='}</option>
                                                        <option value={'<='}>{'<='}</option>
                                                    </>
                                                )}
                                                {(props.filter.Data[props.curFilter].Type === 'number' || props.filter.Data[props.curFilter].Type === 'text') && <option value={'LIKE'}>LIKE</option>}
                                                {props.filter.Data[props.curFilter].Type === 'dropdownMulti' && (
                                                    <>
                                                        <option value={''}></option>
                                                        <option value={'IN'}>IN</option>
                                                        <option value={'NOT IN'}>NOT IN</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    )}
                                    <button className="mfx-button button-border" onClick={removeFilter}>
                                        {window.Dictionary.getTranslation(14463)}
                                    </button>
                                </>
                            )}
                        </>
                    )}
                </div>
            )}
        </div>
    );
}
